import { render } from "./ArticleGalleryComp.vue?vue&type=template&id=6458473f&scoped=true"
import script from "./ArticleGalleryComp.vue?vue&type=script&lang=js"
export * from "./ArticleGalleryComp.vue?vue&type=script&lang=js"

import "./ArticleGalleryComp.vue?vue&type=style&index=0&id=6458473f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6458473f"]])

export default __exports__